import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">深度报道网红圈重大黑料事件，完整还原真相</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200/50 transition-all cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    i === 0 ? 'h-56 md:h-64' : 'h-44 md:h-48'
                  }`}
                  width={i === 0 ? 800 : 600}
                  height={i === 0 ? 340 : 260}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 text-xs font-semibold bg-primary-500 text-white px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>

              <div className="p-4 md:p-5">
                <h3 className={`font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 ${
                  i === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}>
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}